module.exports = __webpack_public_path__ + "static/media/snowflake-2.a0b68bb3.svg";